<template>
  <div class="setup_step card">
    <h4>Set up pricing for add-ons</h4>
    <p class="step-descripion">
      One way to increase revenue per user is to offer paid upgrades within the platform that provide additional
      features such as more data, keywords, and credits. Set these below.
    </p>
    <manage-addons-form
      :user-addons="addons"
      :use-cards="true"
      @submit="submit"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ManageAddonsForm from "../includes/ManageAddonsForm";
import Swal from "sweetalert2";
import SweetToast from "../../../SweetToast";

export default {
  components: {
    ManageAddonsForm,
  },
  computed: {
    ...mapGetters('productManager', [
      'softwareProduct',
    ]),
    ...mapGetters('addonManager', [
      'addons',
    ]),
  },
  methods: {
    ...mapActions('merchantCentreSetupWizard', [
      'setCurrentStep',
      'storeProductsAndAddons',
      'setLoadingState',
    ]),
    submit() {
      this.setLoadingState(true);
      this.storeProductsAndAddons()
        .then(() => {
          SweetToast.fire({
            icon: "success",
            title: "Products stored successfully.",
          });
          this.setCurrentStep('REGISTRATION');
        })
        .catch(({response}) => {
          const { status } = response;

          if (status === 422) {
            Swal.fire({
              icon: "warning",
              title: "Whoops!",
              text: 'Sorry, there were some problems with your submission. '+
                'Please check your product and add-on configuration.',
            });
            return;
          }

          Swal.fire({
            icon: "warning",
            title: "Whoops!",
            text: 'Sorry, there was a problem saving your configuration. '+
              'Please try again later.',
          });

        })
        .finally(() => this.setLoadingState(false));
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
